module.exports = __webpack_public_path__ + "396cf2a5fda19a29e5d7ef8fa97d6b42.png";